var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-badge',{attrs:{"pill":"","variant":"secondary"}},[_c('b-icon',{staticClass:"ml-1 mr-2",staticStyle:{"width":"fit-content"},attrs:{"icon":"clock","aria-label":"Help"}}),_vm._v(" "+_vm._s(_vm.formatedTime)+" ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }